import React, { useEffect } from "react";
import app from "nystem";

export default ({ imageRef, imgSrc, setRetry, ...props }) => {
  useEffect(() => {
    // Return nothing: a returned value would replace the connection event for later listeners.
    const onConnection = ({ connected }) => {
      if (connected && imgSrc === "error") setRetry((retry) => retry + 1);
    };
    app.connection.on("connection", onConnection);
    return () => app.connection.off("connection", onConnection);
  }, [imageRef, imgSrc, setRetry]);
  return React.createElement("div", { ...props, ref: imageRef });
};
